<template>
  <div :class="['home-container', breakpoint]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breakpoint: 'xl',
    };
  },
  mounted() {
    this.updateBreakpoint();
    window.addEventListener('resize', this.updateBreakpoint);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateBreakpoint);
  },
  methods: {
    updateBreakpoint() {
      this.breakpoint = this.$viewport.getCurrentBreakpoint();
    },
  },
};
</script>

<style lang="scss" scoped>
.home-container {
  width: 100%;
  margin: 0 auto;
  position: relative;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

/* 移动端特定样式 */
.xs .content-item,
.sm .content-item {
  margin-bottom: 1rem;
}
</style>
